require('./home/home');
require('./import/import-objects');
require('./rmsobjects/rms-objects');
require('./orders/orders');
require('./customers/customers');
require('./request/request');
//require('./calendar/calendar');
require('./import/importcol');
require('./import/importcol-grid');
require('./general/feedback-link');

import AclPlugin from './plugins/permissions/permissions.js';
Vue.use(AclPlugin);

import VueFormGenerator from 'vue-form-generator'
// TODO: Darstellungsfehler durch überschriebene CSS Klassen
//import 'vue-form-generator/dist/vfg.css'
Vue.use(VueFormGenerator);

import ImportcolGrid from './import/importcol-grid';
Vue.component('importcol-grid', ImportcolGrid);
import WindowCreateCustomer from './customers/window-create-customer';
Vue.component('window-create-customer', WindowCreateCustomer);


import importExcel from './import-excel/import-excel';
Vue.component('import-excel', importExcel);

// region Dashboard widgets
/*
import rmsDashboard from './dashboard/dashboard';
Vue.component('rms-dashboard', rmsDashboard);



*/


/*
import requestsGrid from './request/requests-grid';
Vue.component('requests-grid', requestsGrid);
*/
// endregio

// region RMS-Objects

import formRmsObject from './rmsobjects/form-rms-object';
Vue.component('form-rms-object', formRmsObject);

/*
import rmsObjectsGrid from './rmsobjects/rms-objects-grid';
Vue.component('rms-objects-grid', rmsObjectsGrid);
 */

import rmsObjectsDetail from './rmsobjects/details/rms-objects-detail';
Vue.component('rms-objects-detail', rmsObjectsDetail);
// endregion

// region Calendar-BR
/*
import calendarbr from './calendar/calendarbr';
Vue.component('calendarbr', calendarbr);
 */
// endregion


// region Orders


import orderCreate from './orders/order-create';
Vue.component('order-create', orderCreate);

import orderEdit from './orders/order-edit';
Vue.component('order-edit', orderEdit);

import formOrder from './orders/form-order';
Vue.component('form-order', formOrder);

import orderDisplay from './orders/order-display';
Vue.component('order-display', orderDisplay);

import datePicker from './orders/date-picker';
Vue.component('date-picker', datePicker);

// endregion

// region Customers
/*
import customersGrid from './customers/customers-grid';
Vue.component('customers-grid', customersGrid);
*/

import formCustomer from './customers/form-customer';
Vue.component('form-customer', formCustomer);
// endregion

// region Request
import formRequest from './request/form-request';
Vue.component('form-request', formRequest);

import requestCreate from './request/request-create';
Vue.component('request-create', requestCreate);

import requestPrevious from './request/request-previous';
Vue.component('request-previous', requestPrevious);

import formApprove from './request/form-approve';
Vue.component('form-approve', formApprove);

// endregion

// region Statistics
import statisticsHome from './statistics/statistics-home';
Vue.component('statistics-home', statisticsHome);
// endregion

import feedbackLink from './general/feedback-link';
Vue.component('feedback-link', feedbackLink);

import privacyPolicy from "./staticpages/privacy-policy.vue";
Vue.component('privacy-policy', privacyPolicy);
